<router-outlet></router-outlet>
<ngx-ui-loader [fgsTemplate]="foregroundSpinner"></ngx-ui-loader>

<ng-template #foregroundSpinner>
	<loader></loader>
</ng-template>